import type { PropsWithChildren } from 'react';

import { useRegionParamEffect } from '@/application/hooks';

/** status 호스트 전역 라우팅 부수 효과(예: region 쿼리 동기화). */
const ClientSideGuard = ({ children }: PropsWithChildren) => {
  useRegionParamEffect();

  return <>{children}</>;
};

export default ClientSideGuard;
